<megastore-header></megastore-header>
<router-outlet></router-outlet>
<megastore-footer></megastore-footer>
